import { Injectable } from '@angular/core';
import {
  HttpCriteria,
  SuperHttpClientProvider
} from '@app/core/http';

@Injectable({
  providedIn: 'root'
})
export class SensorDataService {
  constructor(private $shttp: SuperHttpClientProvider) {}

  getSensorData(criteria: HttpCriteria) {
    return this.$shttp.default.filter('/admin/statisticalData', criteria);
  }

  getSensorData2(criteria: HttpCriteria, sensorDataColumnValue: string) {
    const params = criteria
      .toHttpParams()
      .append('sensorDataColumn', sensorDataColumnValue);
    return this.$shttp.default.get('/admin/statisticalData', { params });
  }

  getPluviometerData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getPluviometerStatisticalData',
      settings
    );
  }

  getFlowmeterData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getFlowmeterStatisticalData',
      settings
    );
  }

  getHumidityData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
    sensorDataColumn: string;
    sensorDataColumnSumatory: string;
    sensorType?: string;
  }) {
    return this.$shttp.default.post(
      '/admin/getHumidityStatisticalData',
      settings
    );
  }

  getDendrometerData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getDendrometerStatisticalData',
      settings
    );
  }

  getDigitalData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getDigitalStatisticalData',
      settings
    );
  }

  getConductivityData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getConductivityStatisticalData',
      settings
    );
  }

  getThermometerData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getThermometerStatisticalData',
      settings
    );
  }

  getLeafHumidityData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getLeafHumidityStatisticalData',
      settings
    );
  }

  getWaterConductivityData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getThermometerStatisticalData',
      settings
    );
  }

  getAnemometerData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getAnemometerStatisticalData',
      settings
    );
  }

  getBatteryData(settings: {
    minDate: string;
    maxDate: string;
    idModule: number;
  }) {
    return this.$shttp.default.post(
      '/admin/getBatteryStatisticalData',
      settings
    );
  }
}
